import { Button, cn, Tooltip } from "@heroui/react";
import { Icon } from "@iconify/react";

interface RefreshButtonProps {
  isFetching: boolean;
  onRefresh: () => void;
}

export const RefreshButton = ({
  isFetching,
  onRefresh,
}: RefreshButtonProps) => (
  <Tooltip delay={300}>
    <Tooltip.Trigger>
      <Button
        isIconOnly
        aria-label="Refresh"
        size="sm"
        variant="tertiary"
        onPress={onRefresh}
      >
        <Icon
          className={cn(isFetching && "animate-spin")}
          icon="solar:refresh-linear"
          width={18}
        />
      </Button>
    </Tooltip.Trigger>
    <Tooltip.Content>Refresh</Tooltip.Content>
  </Tooltip>
);
